import { SetDefaultData, FetchFinancialInstitutionRequest, UpdateField, UpdateFinancialInstitutionRequest } from './../financial-institutions.actions';
import { getUpdateFinancialInstitutionState } from '../financial-institutions.selectors';
import Validator from '@shared/validatorjs/src/validator';
import { ActivatedRoute } from '@angular/router';
import { Store, select } from '@ngrx/store';
import { Component, OnInit, OnDestroy } from '@angular/core';
import FormTrait from 'src/app/traits/form.trait';
import { Subscription } from 'rxjs';
import { Map } from 'immutable';

@Component({
  selector: 'app-update-financial-institution',
  templateUrl: './update-financial-institution.component.html',
  styleUrls: ['./update-financial-institution.component.css']
})
export class UpdateFinancialInstitutionComponent extends FormTrait implements OnInit, OnDestroy {

  private state$: Subscription;
  public isLoading: boolean;
  public financialInstitutionId: number;

  constructor(public store: Store<any>, private route: ActivatedRoute) {
    super()
  }

  ngOnInit() {
    this.financialInstitutionId = parseInt(this.route.snapshot.paramMap.get("id"))
    this.store.dispatch<any>(new SetDefaultData('updateFinancialInstitution'))
    this.state$ = this.store.pipe(select(getUpdateFinancialInstitutionState)).subscribe(state => {
      this.state = state;
      this.isLoading = state.get('isLoading')
    });

    this.store.dispatch<any>(new FetchFinancialInstitutionRequest(this.financialInstitutionId))
  }

  ngOnDestroy(){
    this.state$.unsubscribe();
  }

  public handleFieldChange(e: any, name: null | string = null): void {

    this.store.dispatch(
      new UpdateField(name || e.target.name, name ? e : e.target.value, 'updateFinancialInstitution.data')
    );

    this.store.dispatch(
      new UpdateField('validationErrors', this.state
        .get('validationErrors')
        .delete(name || e.target.name), 'updateFinancialInstitution')
    );
  }

  validation() {
    const data = this.state.get('data');
    const rules = {
      name: "required",
      description: "required",
    };
    const validator = new Validator(
      data.toJS(),
      rules,
    );

    return validator;
  }

  public onSubmit(e: Event): void {

    e.preventDefault();

    const validation = this.validation();
    const payload = this.state.get('data').toJS();

    if (validation.passes()) {
      this.store.dispatch(new UpdateFinancialInstitutionRequest(this.financialInstitutionId, payload));
    } else {
      this.store.dispatch<any>(
        new UpdateField('validationErrors', validation.errors.errors, 'updateFinancialInstitution')
      );
    }
  }

}
